<!-- from https://codepen.io/craftedbygc/pen/yyJamr //-->

<template>
  <!-- Xmas Wrapper -->
  <div class="xmas">

    <!-- Let it snow! -->
    <canvas id="xmas"></canvas>
    <audio id="sound-ring">
      <source src="https://soundbible.com/mp3/Sleigh%20Bells%20Ringing-SoundBible.com-1890102065.mp3"/>
      Your browser isn't invited for super fun audio time.
    </audio>
    <audio id="sound-hoho">
      <source src="https://soundbible.com/mp3/Ho%20Ho%20Ho%20St%20Nick-SoundBible.com-1954250969.mp3">
    </audio>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'FunSnow',
  mounted() {
    this.initLetItSnow()

    setTimeout(this.soundRinging, 30 * 1000)
    setTimeout(this.soundHoho, 60 * 1000)
  },
  methods: {
    soundRinging: function () {
      const audio = document.getElementById("sound-ring");
      audio.play();
    },
    soundHoho: function () {
      const audio = document.getElementById("sound-hoho");
      audio.play();

      setTimeout(this.soundHoho, 600 * 1000)
    },
    initLetItSnow: function () {

      (function () {
        window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame ||
            function (callback) {
              window.setTimeout(callback, 1000 / 60);
            };
      })();

      let flakes = [];
      let canvas = document.getElementById("xmas");
      let ctx = canvas.getContext("2d");
      let mX = -100;
      let mY = -100;

      const flakeCount = 450;

      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      function snow() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        for (let i = 0; i < flakeCount; i++) {
          let flake = flakes[i],
              x = mX,
              y = mY,
              minDist = 250,
              x2 = flake.x,
              y2 = flake.y;

          let dist = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y));
          // let dx = x2 - x;
          // let dy = y2 - y;

          if (dist < minDist) {
            let force = minDist / (dist * dist);
            let xcomp = (x - x2) / dist;
            let ycomp = (y - y2) / dist;
            // deltaV = force / 2;
            let deltaV = force;

            flake.velX -= deltaV * xcomp;
            flake.velY -= deltaV * ycomp;

          } else {
            flake.velX *= .98;
            if (flake.velY <= flake.speed) {
              flake.velY = flake.speed
            }
            flake.velX += Math.cos(flake.step += .05) * flake.stepSize;
          }

          ctx.fillStyle = "rgba(255,255,255," + flake.opacity + ")";
          flake.y += flake.velY;
          flake.x += flake.velX;

          if (flake.y >= canvas.height || flake.y <= 0) {
            reset(flake);
          }

          if (flake.x >= canvas.width || flake.x <= 0) {
            reset(flake);
          }

          ctx.beginPath();
          ctx.arc(flake.x, flake.y, flake.size, 0, Math.PI * 2);
          ctx.fill();
        }
        requestAnimationFrame(snow);
      }

      function reset(flake) {
        flake.x = Math.floor(Math.random() * canvas.width);
        flake.y = 0;
        flake.size = (Math.random() * 3) + 2;
        flake.speed = (Math.random() * 1) + 0.5;
        flake.velY = flake.speed;
        flake.velX = 0;
        flake.opacity = (Math.random() * 0.5) + 0.3;
      }

      function init() {
        for (let i = 0; i < flakeCount; i++) {
          let x = Math.floor(Math.random() * canvas.width);
          let y = Math.floor(Math.random() * canvas.height);
          let size = (Math.random() * 3) + 4;
          let speed = (Math.random() * 1) + 0.5;
          let opacity = (Math.random() * 0.5) + 0.3;

          flakes.push({
            speed: speed,
            velY: speed,
            velX: 0,
            x: x,
            y: y,
            size: size,
            stepSize: (Math.random()) / 160,
            step: 0,
            opacity: opacity
          });
        }

        snow();
      }

      canvas.addEventListener("mousemove", function (e) {
        mX = e.clientX
        mY = e.clientY
      });

      window.addEventListener("resize", function () {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      })

      init();
    }
  }
})

</script>

<style scoped lang="scss">

.xmas {
  height: 100%;
  width: 100%;
  position: fixed;
  pointer-events: none;

  // Let it snow!
  #xmas {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 2;
  }
}
</style>
